// extracted by mini-css-extract-plugin
export default {"component":"EYp5w","ascending":"nqasV","icon":"sIhn1","active":"rcU0U"};